import { ThisConnector } from '../../../api/connector'
import { BaseApiResponse } from '../../../api/shared'

export interface BulkIncludeRoutesArgs {
  organizationUuid: string
  applicationUuid: string
  routeHashes: string[]
}

export async function bulkIncludeRoutes(
  this: ThisConnector,
  { organizationUuid, applicationUuid, routeHashes }: BulkIncludeRoutesArgs
) {
  return this.connector.put<BaseApiResponse>(
    `/${organizationUuid}/applications/${applicationUuid}/route/include`,
    {
      routeHashes
    }
  )
}
